import { render, staticRenderFns } from "./SessionCalendar.vue?vue&type=template&id=a0b903e2&scoped=true"
import script from "./SessionCalendar.vue?vue&type=script&lang=js"
export * from "./SessionCalendar.vue?vue&type=script&lang=js"
import style0 from "./SessionCalendar.vue?vue&type=style&index=0&id=a0b903e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b903e2",
  null
  
)

export default component.exports